import {
  PricingModule,
  PricingState,
  PricingMutationTree,
  PricingActionTree,
  PricingGetterTree,
} from '@/store/@types/pricing';

import { getPaymentPageData } from '@/api/bankroll';
import { formatPackages } from '@/helper/utils';

import {
  membershipBenefits,
  offerBenefits,
  customerReviews,
} from '@/data/pricing';

const state: PricingState = {
  membershipBenefits,
  offerBenefits,
  customerReviews,
  activePackageName: '1y',
  isRefoundAgreementAccepted: true,
  initialData: null,
  isTimerVisible: false,
  isTimerEnded: false,
  isDiscountVisible: false,
  isFixedPlanVisible: false,
};

const mutations: PricingMutationTree = {
  SET_ACTIVE_PACKAGE_NAME(state, name) {
    state.activePackageName = name;
  },

  SET_REFOUND_AGREEMENT_ACCEPTANCE(state, isAccepted) {
    state.isRefoundAgreementAccepted = isAccepted;
  },

  SET_INITIAL_DATA(state, data) {
    state.initialData = data;
  },

  SET_TIMER_VISIBLE(state, isVisible) {
    state.isTimerVisible = isVisible;
  },

  SET_TIMER_ENDED(state, isEnd) {
    state.isTimerEnded = isEnd;
  },

  SET_DISCOUNT_VISIBLE(state, isVisible) {
    state.isDiscountVisible = isVisible;
  },

  SET_FIXED_PLAN_VISIBLE(state, isVisible) {
    state.isFixedPlanVisible = isVisible;
  },
};

const actions: PricingActionTree = {
  async getPaymentPageData({ commit }) {
    const data = await getPaymentPageData();

    commit('SET_INITIAL_DATA', data);
  },

  setActivePackageName({ commit }, name) {
    commit('SET_ACTIVE_PACKAGE_NAME', name);
  },

  changeRefoundAgreementAcceptance({ commit }, isAccepted) {
    commit('SET_REFOUND_AGREEMENT_ACCEPTANCE', isAccepted);
  },

  setTimerVisibility({ commit }, isVisible) {
    commit('SET_TIMER_VISIBLE', isVisible);
  },

  setTimerEnded({ commit }, isEnd) {
    localStorage.setItem('timerEnded', 'true');

    commit('SET_TIMER_ENDED', isEnd);
  },

  setDiscountVisible({ commit }, isVisible) {
    commit('SET_DISCOUNT_VISIBLE', isVisible);
  },

  setFixedPlanVisible({ commit }, isVisible) {
    commit('SET_FIXED_PLAN_VISIBLE', isVisible);
  },
};

const getters: PricingGetterTree = {
  packages: (state) => {
    const packageList = state.initialData?.packageList;
    return packageList ? formatPackages(packageList) : null;
  },

  isPackagesEmpty: (state) => {
    const packageList = state.initialData?.packageList || [];
    return packageList.length === 0;
  },

  activePackage: (state, getters) => {
    if (!getters.packages) return null;

    return getters.packages[state.activePackageName] || null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as PricingModule;
